"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberInputSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const zod_1 = require("zod");
/**
 * PhoneNumber Validation
 *
 * Many options exist on the internet for complex phone validation
 * regex but it causes issues:
 *
 * - we correctly get a security warning for catastrophic backtracking on deeply nested RegExp
 * - these complex expressions are hard for everyone to read & debug
 *
 * For that reason this component takes the approach of simple separate patterns
 * that check for match cases and then do a simple "or" check.  This avoids the
 * performance problems and allows any developer to quickly add/subtract from the
 * valid patterns.  Note: consumer application can also provide it's own
 * validation for number as well.
 */
const phonePatterns = [/^(\d{10,12})$/, /^(\+\d{11,12})$/, /^(\d{3}-\d{3}-\d{4})$/, /^(\+\d{1,2}-\d{3}-\d{3}-\d{4})$/];
// eslint-disable-next-line security/detect-non-literal-regexp
const phoneNumberRegex = new RegExp(phonePatterns.map((p) => p.source).join('|'));
exports.PhoneNumberInputSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    // validations:
    default: zod_1.z.coerce.string().regex(phoneNumberRegex, 'Valid Phone Number Required'),
});
function PhoneNumberInput({ label = 'Phone Number', name, required = true, autoComplete = 'off', dataTestId, }) {
    const fieldId = (0, react_1.useId)();
    const testId = dataTestId ? `${dataTestId}_${fieldId}` : 'form_field_phonenumber_input';
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = errors[name];
    return ((0, jsx_runtime_1.jsx)(material_1.TextField, Object.assign({ type: "string", fullWidth: true, autoComplete: autoComplete, label: label, error: Boolean(error), helperText: error === null || error === void 0 ? void 0 : error.message, required: required }, field, { onChange: (e) => field.onChange(e.target.value || ''), inputProps: {
            'data-test-id': testId,
        } })));
}
exports.default = PhoneNumberInput;
//# sourceMappingURL=PhoneNumberInput.js.map